import { api } from "./api";

export const postFavorito = (favorito: any) => api.post(`Favorito/incluir/`, favorito);
export const getFavorito = (cdUsuario: string) => api.get(`Favorito/buscar/${cdUsuario}`);
export const deleteFavorito = (favorito: any) => api.delete(`Favorito/excluir/`, favorito);
